import React from "react";


const NotFound = (props) => {
    return (
        <div className="not-found">
            <div className="container">
                <div className="center">
                    <h1>404</h1>
                    <h2>Page Not Found!</h2>
                    <a href="/">Back to Home</a>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
